import type { ENTITY_TYPES } from '@sales-center/common'
import { useGetCampaignsOnMount } from '@user/store/campaigns'
import { useGetCustomFieldsOnMount } from '@user/store/customFields'
import { useGetEntityFormSettingsOnMount } from '@user/store/entityFormSettings'
import { useGetSalesFunnelListOnMount } from '@user/store/salesFunnel'
import { useGetSalesTeamListOnMount } from '@user/store/salesTeam'
import { useGetSourcesOnMount } from '@user/store/sources'
import { useGetTargetPestsOnMount } from '@user/store/targetPests'

type Props = {
  entityType: ENTITY_TYPES
}

export function useData(props: Props) {
  const { entityType } = props

  const sourceStatus = useGetSourcesOnMount()
  const campaignStatus = useGetCampaignsOnMount()
  const funnelStatus = useGetSalesFunnelListOnMount()
  const targetPestStatus = useGetTargetPestsOnMount()
  const customFieldsLoading = useGetCustomFieldsOnMount()
  const { loading: settingsLoading } =
    useGetEntityFormSettingsOnMount(entityType)
  const teamStatus = useGetSalesTeamListOnMount({
    includeTeamsByBranchId: true,
  })

  return (
    settingsLoading ||
    customFieldsLoading ||
    teamStatus === 'pending' ||
    sourceStatus === 'pending' ||
    funnelStatus === 'pending' ||
    campaignStatus === 'pending' ||
    targetPestStatus === 'pending'
  )
}
